import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./AddService.module.css";
import ClientsDropDown from "./ClientsDropDown";
import IOSSwitch from "../../../../../../utils/IOSSwitch";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AnimatePresence, motion } from "framer-motion";
import MotionWrapperHeight from "../../../../../../assets/Animations/MotionWrapperHeight";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function AddService() {
    const navigateTo = useNavigate();
    const [selectedClient, setselectedClient] = useState(null);
    const [checked, setChecked] = useState(false);
    const [formData, setFormData] = useState({
        serviceName: "",
        description: "",
        price: "",
        every: "",
        recurringPeriod: "Month",
        isAssignTeam: false,
        assignedMember: "",
        hasDeadline: false,
        deadlineValue: "",
        deadlinePeriod: "",
        hasTasks: false,
        taskDescription: "",
    });

    const clients = [
        { id: 1, name: "John Smith", email: "johnsmith@gmail.com" },
        { id: 2, name: "Jane Doe", email: "janedoe@gmail.com" }
    ];

    const handleBackClick = () => navigateTo("/services");

    const handleSwitchChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
    };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Services</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <h3>Add service</h3>

                <form onSubmit={handleSubmit}>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Service name</label>
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="My service"
                            name="serviceName"
                            value={formData.serviceName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className={Classes.flexCol1}>
                        <div className={'flexAlign10'}>
                            <label className={Classes.label}>Description</label>
                            <div className={Classes.optionalText}><h5>Optional</h5></div>
                        </div>
                        <textarea
                            rows="7"
                            className={Classes.inputField}
                            placeholder="Start typing..."
                            style={{ resize: "none" }}
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    <div className="flexAlign" style={{ paddingLeft: '10px', marginBottom: '15px' }}>
                        <FormGroup>
                            <FormControlLabel
                                control={<IOSSwitch checked={checked} onChange={handleSwitchChange} />}
                            />
                        </FormGroup>
                        <div className={Classes.option} style={{ margin: '0' }}>
                            <h5>Recurring service</h5>
                        </div>
                    </div>

                    <label className={Classes.label}>Price</label>
                    <div className={Classes.flexColGroup}>
                        <div className={Classes.flexCol1}>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="$0.00"
                                name="price"
                                value={formData.price}
                                onChange={handleChange}
                            />
                        </div>
                        {checked ?
                            <>
                                <div className={Classes.flexCol1}>
                                    <div className="flexAlign10">
                                        <label className={Classes.label}>every</label>
                                        <input
                                            type="number"
                                            className={Classes.inputField}
                                            placeholder="1"
                                            name="every"
                                            value={formData.every}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className={Classes.flexCol1} >
                                    <select
                                        className={Classes.inputField}
                                        name="recurringPeriod"
                                        value={formData.recurringPeriod}
                                        onChange={handleChange}
                                        style={{ margin: '0' }}
                                    >
                                        <option>Month</option>
                                        <option>Year</option>
                                    </select>
                                </div>
                            </>
                            :
                            <>
                                <div className={Classes.flexCol1}></div>
                                <div className={Classes.flexCol1}></div>
                            </>
                        }
                    </div>

                    {/* Checkboxes with Conditional Rendering */}
                    <div className={Classes.options}>
                        {/* Assign to Team Member */}
                        <div className={Classes.option}>
                            <input
                                type="checkbox"
                                id="check1"
                                name="isAssignTeam"
                                checked={formData.isAssignTeam}
                                onChange={handleChange}
                            />
                            <div>
                                <label htmlFor="check1" >
                                    <h5>Assign to a team member</h5>
                                    <p>Assign orders of this service to a team member.</p>
                                </label>
                                <AnimatePresence>
                                    {formData.isAssignTeam && (
                                        <MotionWrapperHeight>
                                            <div className="flexAlign10" style={{ padding: '2px' }} >
                                                <select
                                                    className={Classes.inputField}
                                                    name="assignedMember"
                                                    value={formData.assignedMember}
                                                    onChange={handleChange}
                                                    placeholder="Days"
                                                    style={{ width: '20rem' }}
                                                >
                                                    <option>John Doe</option>
                                                    <option>John Doe</option>
                                                </select>
                                            </div>
                                        </MotionWrapperHeight>
                                    )}
                                </AnimatePresence>
                            </div>
                        </div>
                        {/* Set a Deadline */}
                        <div className={Classes.option}>
                            <input
                                type="checkbox"
                                id="check2"
                                name="hasDeadline"
                                checked={formData.hasDeadline}
                                onChange={handleChange}
                            />
                            <div>
                                <div>
                                    <label htmlFor="check2" >
                                        <h5>Set a deadline</h5>
                                        <p>Helps your team see orders that are due soon.</p>
                                    </label>
                                </div>
                                <AnimatePresence>
                                    {formData.hasDeadline && (
                                        <MotionWrapperHeight>
                                            <div className="flexAlign10" style={{ padding: '2px' }} >
                                                <input
                                                    type="text"
                                                    className={Classes.inputField}
                                                    placeholder="0"
                                                    name="deadlineValue"
                                                    value={formData.deadlineValue}
                                                    onChange={handleChange}
                                                />
                                                <select
                                                    className={Classes.inputField}
                                                    name="deadlinePeriod"
                                                    value={formData.deadlinePeriod}
                                                    onChange={handleChange}
                                                    placeholder="Days"
                                                >
                                                    <option>Days</option>
                                                    <option>Weeks</option>
                                                    <option>Months</option>
                                                    <option>Years</option>
                                                </select>
                                            </div>
                                        </MotionWrapperHeight>
                                    )}
                                </AnimatePresence>
                            </div>
                        </div>

                        {/* Set Tasks */}
                        <div className={Classes.option}>
                            <input
                                type="checkbox"
                                id="check3"
                                name="hasTasks"
                                checked={formData.hasTasks}
                                onChange={handleChange}
                            />
                            <div>
                                <label htmlFor="check3">
                                    <h5>Set tasks</h5>
                                    <p>Set tasks for your team to follow on this order.</p>
                                </label>
                                <AnimatePresence>
                                    {formData.hasTasks && (
                                        <MotionWrapperHeight>
                                            <div style={{ padding: '2px' }} >
                                                <input
                                                    type="text"
                                                    className={Classes.inputField}
                                                    placeholder="Task 1"
                                                    // value={formData}
                                                    onChange={handleChange}
                                                    style={{ width: '20rem' }}
                                                />
                                            </div>
                                            <div style={{ padding: '2px' }} >
                                                <textarea
                                                    rows="3"
                                                    className={Classes.inputField}
                                                    placeholder="Short description of the task"
                                                    name="taskDescription"
                                                    value={formData.taskDescription}
                                                    onChange={handleChange}
                                                    style={{ width: '20rem' }}
                                                ></textarea>
                                            </div>
                                            <div style={{ padding: '2px' }} >
                                                <button className={`${Classes.submitBtn} ${Classes.whiteBtn}`}>
                                                    <h5>Add task</h5>
                                                </button>
                                            </div>
                                        </MotionWrapperHeight>
                                    )}
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>

                    <div className={Classes.flexEnd}>
                        <button type="submit" className={Classes.submitBtn}>
                            <h5>Add service</h5>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
